<template>
  <div>
    <i class="far fa-map-marker-alt fa-fw"></i>
    {{ $t('EVENTS.LABEL.EVENT_LOCATION') }}:
    {{ locationAddress }}
  </div>
</template>

<script>
export default {
  name: 'EventLocationComponent',
  props: {
    locationAddress: {
      type: String,
    },
    includeIconAndLabel: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped></style>
